<div class="creator-page">

  <div class="page-header">
    <button mat-icon-button type="button" routerLink="/policy-template" matTooltip="Back to Policy Templates">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="header-text">
      <h2 class="page-title">New Policy Template</h2>
      <p class="page-subtitle">Select the type of resource to configure a policy for.</p>
    </div>
  </div>

  <div class="card-grid">

    <mat-card class="resource-card" (click)="selectType('vm')">
      <mat-card-content class="card-body">
        <mat-icon class="card-icon">computer</mat-icon>
        <h3 class="card-title">VM Policy</h3>
        <p class="card-desc">Configure daily and class-end cleanup actions for virtual machine resources.</p>
      </mat-card-content>
    </mat-card>

    <mat-card class="resource-card" (click)="selectType('user-account')">
      <mat-card-content class="card-body">
        <mat-icon class="card-icon">manage_accounts</mat-icon>
        <h3 class="card-title">User Account Policy</h3>
        <p class="card-desc">Configure cleanup actions and quota limits for user account subscriptions.</p>
      </mat-card-content>
    </mat-card>

  </div>

</div>
